export interface DesignRefreshEventDetail {
  projectId?: string;
}

const RETRY_DELAYS = [1000, 3000, 7000, 15000, 30000];

export class DesignRefreshCoordinator {
  private readonly timers = new Set<ReturnType<typeof setTimeout>>();

  private active = false;

  constructor(
    private readonly projectId: string,
    private readonly invalidate: () => void,
  ) {}

  acknowledgeSse(): void {
    this.timers.forEach((timer) => clearTimeout(timer));
    this.timers.clear();
    this.active = false;
  }

  request(event: Event): void {
    const detail = (event as globalThis.CustomEvent<DesignRefreshEventDetail>).detail;

    if ((detail?.projectId && detail.projectId !== this.projectId) || this.active) return;
    this.active = true;
    this.invalidate();
    RETRY_DELAYS.forEach((delay, index) => this.schedule(delay, index));
  }

  stop(): void {
    this.acknowledgeSse();
  }

  private schedule(delay: number, index: number): void {
    const timer = setTimeout(() => {
      this.timers.delete(timer);
      this.invalidate();
      if (index === RETRY_DELAYS.length - 1) this.active = false;
    }, delay);

    this.timers.add(timer);
  }
}
